import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';
import store from '@/store';
// import { SettingsSidebarState } from '../modules';

@Module({
  dynamic: true,
  namespaced: true,
  name: 'site',
  store,
})
class SiteModule extends VuexModule {
  // optionsSidebar: SettingsSidebarState = { opened: false };

  isSidebarNavigationCollapsed: boolean = false;

  isSidebarOptionsCollapsed: boolean = true;

  // get isSidebarOpen(): boolean {
  //   return this.isOpen;
  // }

  // @Action
  // async loadState() {
  //
  // }

  @Mutation
  toggleNavigationSidebar() {
    this.isSidebarNavigationCollapsed = !this.isSidebarNavigationCollapsed;
  }

  @Mutation
  toggleOptionsSidebar() {
    this.isSidebarOptionsCollapsed = !this.isSidebarOptionsCollapsed;
  }
}

export default getModule(SiteModule);
